/**
 * Kicks off a single update check on launch. Headless, no UI — mirrors
 * ChartPacksLoader. The check is a no-op off-device (canInstallApk() guards it in
 * the store), so this is safe to always mount. The prompt that may follow is
 * rendered by UpdatePrompt.
 */
import { useEffect } from 'react';
import { useUpdateStore } from '@/store/update';

export function UpdateCheckLoader() {
  const check = useUpdateStore((s) => s.check);
  useEffect(() => {
    void check();
  }, [check]);
  return null;
}
